import React, { useContext } from 'react';

import { useFieldArray } from 'react-final-form-arrays';

import { INPUT_TYPE_DATE, InputWithField } from 'components/Input';
import { BENEFICIARY_BIRTHDAY, BENEFICIARY_OWNER } from 'modules/Inquiry/Form/formFields';

import { FieldValue } from '../BeneficiaryOwners';
import { BeneficiaryOwnersContext } from '../BeneficiaryOwners.context';

const BeneficiaryBirthdate: React.FC = () => {
  const { fieldName, userIndex } = useContext(BeneficiaryOwnersContext);
  const { fields } = useFieldArray<FieldValue>(BENEFICIARY_OWNER);
  const shouldBeDisabled = fields.value[userIndex]?.isAssociatedPerson;
  return (
    <InputWithField
      name={`${fieldName}.${BENEFICIARY_BIRTHDAY}`}
      disabled={shouldBeDisabled}
      type={INPUT_TYPE_DATE}
    />
  );
};

export default BeneficiaryBirthdate;
